import {createAction} from '@reduxjs/toolkit'
import type {FetchBaseQueryError} from '@reduxjs/toolkit/query'

export const setError = createAction<FetchBaseQueryError | null>('https/setError')
